/**
 * Created by Mark on 24/11/2016.
 */

import BaseStore from './base-store.js';
import Constants from '../constants/content.js';
import Class from '../classes/class.js';

class ContentStore extends BaseStore {

    constructor() {
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.modules = [];
        this.catalogs = {};
        this.verbsCatalog = {}
        this.catalogSummary  = {};
    }

    _registerToActions(action) {


        switch(action.actionType)
        {

            case Constants.ON_VERBS_FETCH:
                console.log('hello');
                this.verbsCatalog[action.response.id] = action.response;
                this.emit(Constants.ON_VERBS_FETCH);
                break;
            case Constants.ON_MY_CONTENT_UPDATE:
                this.modules = action.response;
                this.emit(Constants.ON_MY_CONTENT_UPDATE);
                break;

            case Constants.ON_VOCAB_FETCH:
                this.catalogs[action.response.id] = action.response;
                this.emit(Constants.ON_VOCAB_FETCH);
                break;

            case Constants.ON_SUMMARY_FETCH:
                this.catalogSummary[action.response.id] = action.response;
                this.emit(Constants.ON_SUMMARY_FETCH);
                break;
        }
    }

    getCatalogSummary(id){
        return this.catalogSummary[id] ?  this.catalogSummary[id] : {id:null,summary:[]}
    }

    getCatalog(id){
        return this.catalogs[id] ?  this.catalogs[id] : {id:null,vocab:[]}
    }

    getVerbs(id){
        return this.verbsCatalog[id] ?  this.verbsCatalog[id] : {id:null,verbs:[]}
    }

}

export default new ContentStore();


// WEBPACK FOOTER //
// ./src/store/content-store.js